import { useLocation, Navigate, Outlet } from "react-router-dom";

const UserRoute = () => {
  const token = localStorage.getItem("jwtToken");
  const userData = JSON.parse(localStorage.getItem("user"));

  const location = useLocation();
  return token ? (
    <Navigate to="/dashboard" state={{ from: location }} replace />
  ) : (
    <Outlet />
  );
};

export default UserRoute;
